import React, { useState } from 'react'
import Sidebar from './Sidebar'
import Header from './Header'

function Layout({ children }) {

  const [isSidebarCollapsed, setSidebarCollapsed] = useState(false);
  const toggleSidebar = () => {
    setSidebarCollapsed(prevState => !prevState);
  };

  return (
    <div className='layout-wrapper'>
      <Sidebar isCollapsed={isSidebarCollapsed} setIsCollapsed={setSidebarCollapsed} />
      <div className='body-wrapper'>
        <Header toggleSidebar={toggleSidebar} />
        <main className='page-main'>{children}</main>
      </div>
    </div>
  )
}

export default Layout